/* eslint-disable no-irregular-whitespace */
import Chart from 'react-apexcharts';

interface cloudType {
  cloud: string,
  usage: number
}
interface prop {
  cloudData: cloudType[],
  activeCloud: boolean,
  message: string,
}

const CloudUsage = ({ cloudData, activeCloud, message }: prop) => (
  <div className="card CardHeight">
    <div className="card-body mx-3">
      <h4 style={{ textAlign: 'center' }}>Cloud Usage Distribution</h4>
      {!activeCloud && <h6 className="text-center cloudHeading">{message}</h6>}
      <Chart
        type="donut"
        series={[cloudData[0].usage, cloudData[1].usage, cloudData[2].usage, cloudData[3].usage]}
        options={{
          labels: [cloudData[0].cloud, cloudData[1].cloud, cloudData[2].cloud, cloudData[3].cloud],
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                },
              },
            },

          },
          dataLabels: {
            enabled: true,
          },

        }}
      />
    </div>
  </div>
);
export default CloudUsage;
